import React from 'react';
import { Typography } from 'seagull';
import WithLegendDot from "../WithLegendDot/WithLegendDot";
import styles from "./CustomLegend.module.scss";
/**
 * Renders a legend to be used in recharts graphs using the recharts Legend component
 * with "content" prop.
 */
export default function CustomLegend(props) {
  const {
    items,
    testid,
    gap
  } = props;
  return /*#__PURE__*/React.createElement("ul", {
    className: styles.root,
    "data-testid": testid,
    style: {
      gap
    }
  }, items.map((_ref, idx) => {
    let {
      label,
      color
    } = _ref;
    return /*#__PURE__*/React.createElement(WithLegendDot, {
      key: idx,
      color: color
    }, /*#__PURE__*/React.createElement(Typography, {
      as: "span",
      variant: "paragraph2",
      skin: "secondary"
    }, label));
  }));
}